import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', company: '', service: '', message: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thanks! We\'ll be in touch soon.');
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__left">
        <span className="label">Get In Touch</span>
        <h2>Let's Start <br /><em>Something Great</em></h2>
        <p>Tell us about your brand, your goals, and where you want to go. We'll get back to you within 24 hours.</p>

        <div className="contact__info">
          <div className="contact__info-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <span>info@beyondigital.co.uk</span>
          </div>
          <div className="contact__info-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <span>Mumbai | Dubai | London</span>
          </div>
        </div>
      </div>

      <div className="contact__form-wrapper">
        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input id="firstName" name="firstName" type="text" placeholder="John" value={formData.firstName} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input id="lastName" name="lastName" type="text" placeholder="Doe" value={formData.lastName} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input id="email" name="email" type="email" placeholder="john@company.com" value={formData.email} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="company">Company</label>
            <input id="company" name="company" type="text" placeholder="Your Company" value={formData.company} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="service">Service Interested In</label>
            <select id="service" name="service" value={formData.service} onChange={handleChange}>
              <option value="">Select a service</option>
              <option>Social Media Marketing</option>
              <option>Content Creation</option>
              <option>SEO</option>
              <option>Paid Ads</option>
              <option>CRM & Automation</option>
              <option>Graphic Design</option>
              <option>Email Marketing</option>
              <option>Website Generation</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" placeholder="Tell us about your project..." rows={4} value={formData.message} onChange={handleChange} />
          </div>
          <button type="submit" className="btn btn--primary btn--full">
            Send Message →
          </button>
          <p className="form-note">We respond within 24 hours. No spam, ever.</p>
        </form>
      </div>
    </section>
  );
}